import React, { FunctionComponent } from 'react';
import Check from '@crehana/crehana-icons/lib/CheckNew';
import { WRAPPER, DISABLED_WRAPPER, CHECKBOX } from './classnames';
import Text from '../Text';
import transition from '../styles/transition';
import { white } from '../styles/colors';
import { ColorType } from '../styles/types';
import { CheckboxProps } from './types';

const Checkbox: FunctionComponent<CheckboxProps> = ({
  checked,
  onChange,
  disabled,
  error,
  darkMode,
  label,
  small,
  className = '',
  wrapperProps,
  'data-testid': dataTestId,
  ...other
}) => {
  let type = 'default';

  if (error) {
    type = 'error';
  }
  if (checked) {
    type = darkMode ? 'checked-dark' : 'checked';
  }

  let labelColor: ColorType = darkMode ? 'white' : 'base-main';

  if (small || disabled) {
    labelColor = 'gray-dark';
  }

  return (
    <label
      className={`${disabled ? DISABLED_WRAPPER : WRAPPER} ${className}`}
      {...wrapperProps}
    >
      <input
        className="hidden"
        type="checkbox"
        disabled={disabled}
        onChange={onChange}
        data-testid={dataTestId}
        {...other}
      />
      <div
        className={CHECKBOX[type]}
        style={{ transition: transition(['background-color', 'border']) }}
      >
        <Check
          className={!checked ? ' opacity-0' : ''}
          style={{ transition: transition('opacity') }}
          size={16}
          color={white}
        />
      </div>
      {label && (
        <Text
          className={small ? 'ml-8' : 'ml-16'}
          type={small ? 'caption' : 'body3'}
          style={{ transition: transition('color') }}
          color={labelColor}
        >
          {label}
        </Text>
      )}
    </label>
  );
};

export default Checkbox;
